<template>
<header class="master-header" id="master_header">
    <router-link to="/" class="header-logo-link">
      <span>Talent Application Management</span>
      <div class="logo-container">
        <span>by</span>
        <img class="logo" src="@/assets/images/logo-talentplug.svg" alt="Talentplug">
      </div>
    </router-link>
</header>
</template>

<script>
export default {
  name: 'MasterHeader',
  computed: {
  },
  methods: {
  }
}
</script>
